import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_amparo_ley_16986.docx) y en su
// mismo orden, como en ModalCaratulaAmparoPnc. Amparo Ley 16.986 es por ahora una variante de
// Amparo PNC (V256): misma ficha y mismo DTO, pero su papel no lleva los renglones del expediente
// demorado ni del amparo, y suma MAIL, CMO y CUD. El estado actual va a lo ancho.
const CAMPOS = {
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    pacto: { label: 'PACTO', tipo: 'sino' },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto' },

    apellidoNombre: { label: 'APELLIDO/NOMBRE TITULAR', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    domicilio: {
        label: 'DOMICILIO', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    // Las mismas columnas que la ficha de Amparo PNC: "CMO incorporado" y "Tiene CUD".
    cmo: { label: 'CMO', tipo: 'sino', guardable: true },
    cud: { label: 'CUD', tipo: 'sino', guardable: true },

    estadoActual: { label: 'ESTADO ACTUAL DEL TRÁMITE ADMINISTRATIVO', tipo: 'texto', guardable: true },
    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
};

const LAYOUT = {
    tituloDoc: 'ACCION DE AMPARO LEY 16.986',
    leyendaDoc: 'TRAMITE: PNC',
    cabecera: [['ingreso', 'pacto']],
    filasPrevias: [
        ['claveFiscal', 'claveCvss'],
        ['referencia'],
    ],
    cuerpo: [
        ['apellidoNombre'],
        ['dniCuit'],
        ['domicilio'],
        ['telefono'],
        ['fechaNacimiento'],
        ['estadoCivil'],
        ['mail'],
        ['cmo'],
        ['cud'],
        ['estadoActual'],
        ['observaciones'],
    ],
};

/** Modal de la Carátula de Amparo Ley 16.986: mismo flujo que el de Amparo PNC (HojaCaratula). */
export default function ModalCaratulaAmparoLey16986(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula de Amparo Ley 16.986"
            nombreDocumento="la Carátula de Amparo Ley 16.986"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
